import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Kendo controls
import { Button } from '@progress/kendo-react-buttons';
import { Grid, GridColumn, GridNoRecords } from '@progress/kendo-react-grid';
import { Checkbox, TextArea } from "@progress/kendo-react-inputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
// Kendo provides
import { getter } from "@progress/kendo-react-common";
import { getSelectedState } from '@progress/kendo-react-grid';
// Action
import { setActiveAll, setDisableAll } from '../../../Store/Actions/Common/ActionState';
import { checkAsyncStatus, transferValuesAsync, transferValuesResult } from '../../../Store/Actions/Pages/MainPage';
import { BaseAction } from '../../../Store/Actions/RootAction';
// Class & Component & Funtion
import { customMessage, RedirectWithComponent } from '../../../Constants/Utils';
import { CreateTargetFinancialStatementRequest } from '../../../Models/RequestModel/TransferValuesRequestModel';
import { AllActionId } from '../../../Models/StateModel/ActionStateModel';
import { SelectedFiscalPeriodStateModel } from '../../../Models/StateModel/FiscalPeriodInfoStateModel';
import { Timer } from '../../Common/Timer';
// Import resource
import Router from '../../../Resources/Router.json';
import Screen from "../../../Resources/Screen.json";

const DATA_ITEM_KEY = "Index";
const SELECTED_FIELD = "Selected";
const timer = new Timer(10000);
const CurrencyUnit = [
    {
        Text: "円",
        Id: 0
    },
    {
        Text: "千円",
        Id: 1
    },
    {
        Text: "百万円",
        Id: 2
    }
]

export function TapStripAmountContent(props) {
    const idGetter = getter(DATA_ITEM_KEY);

    const fiscalPeriodModel = useSelector(state => state.MainPage.fiscalPeriodModel);
    const selectedFiscalPeriodInfo = useSelector(state => state.MainPage.selectedFiscalPeriodInfo);
    const actionState = useSelector(state => state.ActionState.actionState);

    const [unitSelected, setUnitSelected] = useState(CurrencyUnit[0]);
    const [isReclass, setIsReclass] = useState(false);
    const [approvalFlowStatus, setApprovalFlowStatus] = useState(false);

    const [fsTypeItems, setFsTypeItems] = useState([]);

    const [selectedFSTypeState, setSelectedFSTypeState] = useState({});
    const [message, setMessage] = useState(null);

    const dispatch = useDispatch();

    useEffect(() => {
        // Dispose timer if component unmount
        return function cleanup() {
            timer.dispose();
        };
    }, [])

    useEffect(() => {
        if (!fiscalPeriodModel || !selectedFiscalPeriodInfo)
            return;

        // Set default value for state
        setMessage(null);
        setUnitSelected(CurrencyUnit[0]);
        setIsReclass(false);

        // Bindding TargetFinancialStatements
        let fsTypes = fiscalPeriodModel.GetTargetFinancialStatementTypes(selectedFiscalPeriodInfo.FiscalPeriodIndex);
        let fsTypeItems = fsTypes.map((item) => {
            return {
                SystemAccount: item.DisplayText,
                Index: item.Value,
                Selected: true
            }
        });

        // Set default checked every state update
        let seletedItems = fsTypeItems.map((item, index) => ({
            [index]: item.Selected
        }));

        setFsTypeItems(fsTypeItems);
        setSelectedFSTypeState(Object.assign({}, ...seletedItems));
    }, [fiscalPeriodModel, selectedFiscalPeriodInfo]);

    // Event change unit currency
    const changeUnit = (event) => {
        setUnitSelected(event.value);
    }

    // Event change ReclassificationType
    const changeReclassificationType = (event) => {
        setIsReclass(event.target.value);
    }

    // Event change ApprovalFlowStatus
    const changeApprovalFlowStatus = (event) => {
        setApprovalFlowStatus(event.target.value);
    }


    const onSelectionChange = (event) => {
        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedFSTypeState,
            dataItemKey: DATA_ITEM_KEY,
        });
        setSelectedFSTypeState(newSelectedState);
    };

    const handleTransferValues = () => {
        // Set value message before transfer
        setMessage(null);

        const callBack = (res) => {
            if (!res) {
                // Redirect error page if don't have response
                return RedirectWithComponent(Router.Error);
            }

            let result = new BaseAction(res);
            if (result.statusCode === 202) {
                // Start polling action CheckStatusAsync
                timer.start(checkAsync, result, true);
            }
            else if (result.statusCode === 400) {
                // Active controll and show message if an error occurs
                dispatch(setActiveAll());
                setMessage(getMessageAfterTransferAsync(result.data));
            }
        }
        if (checkInputBeforeRequest()) {
            // Call action transfer if input is valid
            setMessage(Screen.TransferMessage.Transferring);
            dispatch(setDisableAll());

            let targetValue = new SelectedFiscalPeriodStateModel({
                FiscalPeriodIndex: selectedFiscalPeriodInfo.FiscalPeriodIndex,
                AccTypeIndex: selectedFiscalPeriodInfo.AccTypeIndex,
                FsTypeIndex: getSelectedFsTypeIndex()
            });
            let request = CreateTargetFinancialStatementRequest(fiscalPeriodModel, targetValue, unitSelected.Id, isReclass, approvalFlowStatus);
            let transferStructures = transferValuesAsync(request, callBack);
            dispatch(transferStructures);
        }
    }

    const checkAsync = (transferModel) => {
        if (!transferModel) {
            // Redirect error page if don't have response
            return RedirectWithComponent(Router.Error);
        }

        const callBackCheckAsync = (res) => {
            if (!res) {
                //Redirect error page if don't have response
                return RedirectWithComponent(Router.Error);
            }

            let baseAction = new BaseAction(res);
            if (baseAction.data) {
                if (baseAction.statusCode === 200) {
                    // Dispose timer and call action TransferValuesResult 
                    timer.dispose();
                    handleTransferResult(baseAction);
                }
                else if (baseAction.statusCode === 400) {
                    // Dispose timer, active controlls and show message if an error occurs
                    timer.dispose();
                    dispatch(setActiveAll());
                    let detailMessage = getMessageAfterTransferAsync(baseAction.data);
                    setMessage(detailMessage);
                }
            }
        }

        // Setup param and call action CheckStatusAsync
        let transferModelData = transferModel?.data;
        if (transferModelData) {
            let paramsCheckStatus = {
                AccessKey: transferModelData.AccessKey,
                RequestKey: transferModelData.RequestKey
            };
            const dispatchCheckStatus = checkAsyncStatus(paramsCheckStatus, callBackCheckAsync);
            dispatch(dispatchCheckStatus);
        }
    }

    const handleTransferResult = (checkAsyncModel) => {
        timer.dispose();
        dispatch(setActiveAll());

        const callBackTransferResult = (res) => {
            if (!res) {
                //Redirect error page if don't have response
                RedirectWithComponent(Router.Error);
            }

            // Show message result
            let baseAction = new BaseAction(res);
            let messageResult = getMessageAfterTransferResult(baseAction.data);
            setMessage(messageResult);
        }

        // SetUp param and call action TransferValuesResult
        let result = checkAsyncModel.data;
        if (result) {
            let paramsTransferResult = {
                AccessKey: result.AccessKey,
                RequestKey: result.RequestKey
            }
            let actionTransferResult = transferValuesResult(paramsTransferResult, callBackTransferResult);
            dispatch(actionTransferResult);
        }
    }

    // Custom message transfer
    const getMessageAfterTransferAsync = (transferModel) => {
        let detailMessage = customMessage(transferModel);
        return Screen.TransferMessage.Transferring + "\n" + detailMessage;
    }

    // Custom message transfer result
    const getMessageAfterTransferResult = (transferResultModel) => {
        let resultMessage = Screen.TransferMessage.Transferring + "\n";
        if (transferResultModel?.ResultCode === "Success") {
            return resultMessage + Screen.TransferMessage.TransferSuccess;
        }
        return resultMessage + customMessage(transferResultModel);
    }

    // Check select item before transfer
    const checkInputBeforeRequest = () => {
        let canExcute = true;
        if (Object.keys(selectedFSTypeState).length === 0 || !checkSelectedtatements(selectedFSTypeState)) {
            canExcute = false;
            if (!canExcute) {
                props.onShowErrMessageBox();
            }
        }
        return canExcute;
    }

    const checkSelectedtatements = (selectedState) => {
        for (let key in selectedState) {
            if (selectedState.hasOwnProperty(key)) {
                let value = selectedState[key];
                if (value) {
                    return true;
                }
            }
        }
        return false;
    }

    const getSelectedFsTypeIndex = () => {
        let fsSelectedMap = new Map(Object.entries(selectedFSTypeState));
        let fsTypeSelected = fsTypeItems.map((item) => {
            return fsSelectedMap.get(`${item.Index}`) ? item : null;
        }).filter((el) => {
            return el !== null;
        });

        return fsTypeSelected.map((item) => {
            return item.Index;
        });
    }

    return (
        <React.Fragment>
            <div className="blockTapContent">
                <p style={{ margin: "0px" }}>{Screen.TapStripAmountContent.TitleTransferValues}</p>
                <Grid
                    style={{ minHeight: "123px" }}
                    scrollable="none"
                    data={fsTypeItems.map((item) => ({
                        ...item,
                        [SELECTED_FIELD]: selectedFSTypeState[idGetter(item)],
                    }))}
                    dataItemKey={DATA_ITEM_KEY}
                    selectedField={SELECTED_FIELD}
                    selectable={{
                        enabled: false,
                        drag: false,
                        cell: false,
                        mode: "multiple",
                    }}
                    onSelectionChange={onSelectionChange}
                    reorderable={true}>
                    <GridNoRecords>{Screen.TapStripAmountContent.TitleNoRecord}</GridNoRecords>
                    <GridColumn
                        field={SELECTED_FIELD}
                        width="50px"
                        className="tapAmountHeader"
                    />
                    <GridColumn field="SystemAccount" title={Screen.TapStripAmountContent.SystemAccountTitle} />
                </Grid>
            </div>

            <div className="row col-md-12">
                <div className="row" style={{ paddingTop: "10px", justifyContent: "center" }}>
                    <div style={{ display: "flex" }}>
                        <label style={{ marginBlock: "auto", minWidth: "80px", marginLeft: "16px" }}>{Screen.TapStripAmountContent.LableCurrencyUnit}</label>
                        <DropDownList className="pnxCombobox" style={{ marginLeft: "5px", width: "206px" }}
                            disabled={actionState.IsDisable(AllActionId.CmbUnit)}
                            defaultValue="円"
                            data={CurrencyUnit}
                            dataItemKey="Id"
                            textField='Text'
                            value={unitSelected}
                            onChange={changeUnit}
                        />
                    </div>
                </div>
            </div>
            <div className="row col-md-12" style={{ paddingTop: "5px" }}>
                <Checkbox disabled={actionState.IsDisable(AllActionId.ChkReclass)}
                    defaultChecked={isReclass}
                    checked={isReclass}
                    label={Screen.TapStripAmountContent.CheckBoxReclassName}
                    onChange={changeReclassificationType} />
            </div>

            <div className="row">
                <div className="col-md-6" style={{ display: "flex", alignItems: "center" }}>
                    <Checkbox disabled={actionState.IsDisable(AllActionId.ChkApprovalFlowStatus)}
                        defaultChecked={approvalFlowStatus}
                        checked={approvalFlowStatus}
                        label={Screen.TapStripAmountContent.ApprovalFlowStatus}
                        onChange={changeApprovalFlowStatus} />
                </div>
                <div className="col-md-6" style={{ display: "flex", justifyContent: "right" }}>
                    <Button className="btn pnxBtnPrimary btnSubmit"
                        style={{ minWidth: "80px" }}
                        onClick={handleTransferValues}
                        disabled={actionState.IsDisable(AllActionId.BtnTransferValue)}>
                        {Screen.TapStripAmountContent.ButtonTransferValues}
                    </Button>
                </div>
            </div>
            <div className="row col-md-12" style={{ paddingTop: "10px", paddingLeft: "0px", paddingRight: "0px", marginLeft: "0px" }}>
                <TextArea
                    rows={10} style={{ width: "100%", padding: "15px 15px 0px 0px" }}
                    value={message ? message : ""}
                    readOnly={true}
                />
            </div>
        </React.Fragment>
    )
}